/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseComponent from "./BaseCom";
import Person from "./Person";
import FormInput from "./FormInput";
import Card from "./Card";
import Auth from "../shared/Auth";
import Globals from "../shared/Globals";
import Alert from "./Alert";
import LoadingAlert from "./LoadingAlert";
import { qreq } from "../shared/qrequest";
import Address from "./Address";


export default class User extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            accounts: [],
            providers: [],
            roles: [],
            roleGroups: [],
            serviceGroupList: [],
            providerList: []
        };

        if (!this.props.item.id)
            this.props.item.isActive = true;

        this.isStarRole = this.isStarRole.bind(this);
        this.canEditRoles = this.canEditRoles.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onRoleChange = this.onRoleChange.bind(this);
    }

    async componentDidMount() {
        await this.getSettings();
        Auth.getLogin((u) => {
            this.setState({ user: u, loaded: true });

            qreq.get('/api/account/list', j => {
                if (j.errorCode === 0)
                    this.setState({ accounts: j.list });
            });

            qreq.post('/api/provider/list', {}, j => {
                if (j.errorCode === 0)
                    this.setState({ providers: j.list });
            });

            qreq.get('/api/user/service-group/list', j => {
                if (j.errorCode === 0)
                    this.setState({ serviceGroupList: j.list });
            });

            this.fillList('/api/provider/list', 'providerList', true);

            this.fillList('/api/organization/list', 'organizationList', true);

            this.fillList('/api/role/list', 'roles');

            qreq.get('/api/user/role/list', j => {
                if (j.errorCode === 0) {
                    var list = [];
                    j.list.forEach(i => {
                        if (i.isAssignable)
                            list.push(i);
                    });
                    this.setState({ roleGroups: list });
                }
            });

            if (this.props.item.roles) {
                this.props.item.roles.forEach((i) => {
                    this.state.roles.forEach((j) => {
                        if (j.id === i)
                            j.selected = true;
                    });
                });
            }

            if (this.isStarRole()) {
                this.setState({
                    roles: [
                        { id: 'admin', name: 'Administrator' },
                        { id: 'account-manager', name: 'Account Manager' },
                        { id: 'field', name: 'Field' },
                        { id: 'inventory', name: 'Inventory Manager' }
                    ]
                });
            }
            else {
                this.setState({
                    roles: [
                        { id: 'account-manager', name: 'Account Manager' },
                        { id: 'field', name: 'Field' },
                        { id: 'inventory', name: 'Inventory Manager' }
                    ]
                });
            }
        });

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.item !== prevProps.item) {
            this.setState({ item: this.props.item });
            this.updateRole(this.props.item);
        }
        if (this.state.roles !== prevState.roles) {
            this.updateRole(this.props.item);
        }
    }

    updateRole = (item) => {
        if (this.state.roles) {
            this.state.roles.forEach((i) => {
                if (i.id === parseInt(item.roleGroupID)) {
                    this.setState({ role: i });
                }
            });
        }
    }

    canEditRoles() {
        if (this.props.item.roles.indexOf('*') !== -1)
            return false;
        if (this.props.item.roles.indexOf('master') !== -1 && !Auth.hasRole('*'))
            return false;
        if (this.props.item.roles.indexOf('admin') !== -1 && !Auth.hasRole('master'))
            return false;
        return true;
    }

    isStarRole() {
        return Auth.hasRole('*');
    }

    onChange() {
        this.props.onChange?.();
    }

    onRoleChange(i) {
        if (i) {
            i = Number(i);
            var rg = this.state.roleGroups.find(j => j.id === i);
            if (rg) {
                if (this.props.onRoleChange)
                    this.props.onRoleChange(rg.roles);
            }
            this.props.onRoleChange?.(rg.roles);
            this.checkPrimaryAccountLevel(rg);
        }
        else {
            this.props.onRoleChange?.([]);
            this.checkPrimaryAccountLevel();
        }
    }

    checkPrimaryAccountLevel = (rg, account) => {
        if (!rg)
            rg = this.state.roleGroups.find(j => j.id === this.props.item.roleGroupID);
        if (!account)
            account = this.state.accounts.find(j => j.id === this.props.item.primaryAccountID);
        if (!rg || !account) {
            this.setState({ accountLevelError: false });
            return;
        }
        if (parseInt(rg.accountLevel) !== parseInt(account.level))
            this.setState({ accountLevelError: true });
        else
            this.setState({ accountLevelError: false });
    }

    onPrimaryAccountChange = (v) => {
        if (v) {
            let find = this.state.accounts.find(i => i.id === Number(v));
            if (find) {
                let has = this.props.item.accounts.find(i => i.id === find.id);
                if (!has)
                    this.props.item.accounts.push(find);
            }
            else
                this.onChange();
            this.checkPrimaryAccountLevel(null, find);
        }
        else {
            this.onChange();
            this.checkPrimaryAccountLevel();
        }
    }

    render() {
        if (!this.state.loaded)
            return <LoadingAlert />
        if (!this.props.item)
            return null;
        return (
            <div>
                <Card title="User Info">
                    <div className="row">
                        <div className="col-md">
                            <FormInput model={this.props.item} label="Email Address/Username" name="email" type="email" required={true} onChange={this.onChange} />

                        </div>
                        <div className="col-md">

                            {this.canEditRoles() ?
                                <div className="row">
                                    <div className="col">
                                        <FormInput model={this.props.item}
                                            label="Role"
                                            name="roleGroupID"
                                            type="select"
                                            options={this.state.roleGroups}
                                            required={true}
                                            onChange={i => this.onRoleChange(i)}
                                        />
                                        {this.state.role?.isLinkedToAccounts
                                            && <p className="text-secondary">
                                                This role is linked to accounts. Please select the related accounts below.
                                            </p>}
                                    </div>
                                </div> : ''}

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md">
                            <FormInput model={this.props.item} label="Phone" name="phone" type="tel" required={false} onChange={this.onChange} />
                        </div>
                        <div className="col-md">
                            <div className="d-flex">
                                <div style={{ width: '100px' }}>
                                    <FormInput model={this.props.item} label="Color" name="color" type="color" onChange={this.onChange} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.organizationList && <FormInput model={this.props.item} label="Organization" name="organizationID" type="select" onChange={this.onChange} options={this.state.organizationList} />}
                    {this.props.item.roles.indexOf('partner') > 0 ? <p className="text-primary">For external users: organization is used to limit their access.</p> :
                        <p className="text-muted">For internal users: organization is only used for informational purposes, it does not limit their access.</p>}
                </Card>
                <Person title="User Demographics" item={this.props.item} requestAddress={false} requireOnlyBasic={true} />
                {((this.props.item.roles.indexOf('field') !== -1 || this.props.item.roles.indexOf('account-manager') !== -1)
                    && this.props.item.roles.indexOf('provider') === -1 && this.props.item.roles.indexOf('manager') === -1)
                    || (this.state.role?.isLinkedToAccounts) ? <Card title="Linked Accounts">
                    <FormInput model={this.props.item}
                        name="primaryAccountID"
                        label="Primary Account"
                        type="select"
                        options={this.state.accounts}
                        onChange={this.onPrimaryAccountChange}
                    />
                    {this.state.accountLevelError ? <Alert type="danger" message="The selected role requires a different account level than the selected account." /> : ''}
                    <FormInput model={this.props.item} name="accounts" label="Select Accounts" type="multiselect" options={this.state.accounts} useObjectValue onChange={this.onChange} loadValueOnce />
                </Card> : ''}
                {this.props.item.roles.indexOf('provider') !== -1 ? <Card title="Linked Providers">
                    <FormInput model={this.props.item} name="providers" label="Select Providers" type="multiselect" options={this.state.providers} useObjectValue onChange={this.onChange} />
                </Card> : ''}
                {this.props.item.address ? <Address item={this.props.item.address} /> : null}
                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'LIS') && <Card title="Link to Provider">
                    <FormInput model={this.props.item} label="Provider" name="providerID" type="select" options={this.state.providerList} onChange={this.onChange} />
                </Card>}
                <Card title="Flags">
                    <div className="row">
                        <div className="col-md">
                            {this.props.item.id !== Globals.get('user').id ? <FormInput model={this.props.item} label="User can login" name="isActive" type="switch" onChange={this.onChange} /> : <p>You can not disable your own user.</p>}
                            {this.props.item.id !== 0 ? <FormInput model={this.props.item} label="Send email invitation" name="resendInvite" type="switch" onChange={this.onChange} /> : ''}
                            {this.props.item.resendInvite ? <Alert message="An email will be sent to this user with a link to set their credentials when saved." /> : ''}

                            {this.state.MODEL === 'WMS' && <>
                                <FormInput model={this.props.item} label="Can sign IVR forms." name="canSignIVR" type="switch" onChange={this.onChange} />
                                <FormInput model={this.props.item} label="Receive IVR notification when it is signed." name="notifyIVRSigned" type="switch" onChange={this.onChange} />
                                <FormInput model={this.props.item} label="Is a care coordinator." name="isSalesRep" type="switch" onChange={this.onChange} />
                            </>}
                            <FormInput model={this.props.item} label="Require Multi-Factor Authentication" name="requireMFA" type="switch" onChange={this.onChange} />
                        </div>
                        {this.state.MODEL === 'WMS' && <div className="col-md">
                            <FormInput model={this.props.item} label="Service Approval" name="hasServiceApproval" type="switch" onChange={this.onChange} />
                            <FormInput model={this.props.item} label="Clinical Approval" name="hasClinicalApproval" type="switch" onChange={this.onChange} />
                        </div>}
                    </div>
                </Card>
            </div>
        );

    }
}